var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dueTime"},[_c('i',{staticClass:"far fa-clock"}),_vm._v(" "),_c('small',[_vm._v("Feb 2nd")])])}]

export { render, staticRenderFns }